import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import MainApp from "./App";
import { store } from "./app-redux/store";
import { AppLoader } from "./core/AppLoader";

import "./i18n";
import { getCurrentEnv } from "utils/common-methods";
import { getAccessToken } from "core/common-methods";
import { axiosRequest } from "core/axios";
import { ACCOUNTS_APP_ID } from "@cw-elements/settings-menu";

const sentryEnvs: string[] = ["qa", "staging", "production"];
const envName: string = process.env.REACT_APP_envName || "";
if (sentryEnvs.indexOf(envName) !== -1) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    environment: process.env.REACT_APP_envName,
  });
}

import { CWEnv, initCWElements } from "@cw-elements/config";
import { matchPath } from "react-router";
import { initMfes } from '@cw-elements/mfe-setup/init';
import { PublicRoutes, history } from "core/history";

const initClients = () => {
  let tokens;
  try {
    tokens = JSON.parse(getAccessToken());
  } catch (ignored) {
    tokens = null;
  }

  initCWElements({
    environment: getCurrentEnv() as CWEnv,
    axiosInstance: axiosRequest,
    token: tokens?.access_token,
    currentAppId: ACCOUNTS_APP_ID,
  });
};

initClients();

export const initMfesAccountsManagement = async () => {
  await initMfes({
    "quota-mgt": `${process.env.REACT_APP_CW_ELEMENTS_MFES}/quota-mgt`,
    "hierarchy-mgt": `${process.env.REACT_APP_CW_ELEMENTS_MFES}/hierarchy-mgt`,
    "invite-members": `${process.env.REACT_APP_CW_ELEMENTS_MFES}/invite-members`
  });
}

(async function loadAppLoader() {
  // Only loads mfes on private pages of the app, as all mfes are private
  if (!(PublicRoutes.filter((router: string) => matchPath(history.location.pathname, { path: router, exact: true })).length)) {
    await initMfesAccountsManagement();
  }
  const myapp = new AppLoader();
  const isRedirecting = await myapp.load();
  if (!isRedirecting) {
    ReactDOM.render(
      <Provider store={store}>
        <MainApp />
      </Provider>,
      document.getElementById("root")
    );
  }
})();
